angular.module('app.api', [
  'app.api.auth',
  'app.api.pics',
  'app.api.storage'
]);
